export default function heapAnalyticsPlugin(userConfig) {
  return {
    name: 'heap-analytics-plugin',

    config: {
      appId: userConfig.appId,
    },

    initialize: ({ config }) => {
      if (globalThis.__TEST__) return;

      const { appId } = config;

      // disabling ember-metrics is not enough, heap still tracks just by virtue of being loaded
      const metaTag = document.querySelector('meta[name="disable-metrics"]');

      if (metaTag) {
        return;
      }

      /* eslint-disable */
      // prettier-ignore
      window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||"https:"===document.location.protocol,a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=(r?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};
      heap.load(`${appId}`);
      /* eslint-enable */
    },

    page: () => {
      // nothing to see here
    },

    track: ({ payload }) => {
      const { event } = payload;
      window.heap.track(event, payload.properties);
    },

    identify: ({ payload, config }) => {
      try {
        let {
          traits,
          traits: { email },
        } = payload;

        if (!email) {
          return;
        }

        email = email.toLowerCase();
        const { appId } = config;
        const cookieId = `_hp2_id.${appId}`;

        // when the cookie already exists
        if (document.cookie.indexOf(cookieId) > -1) {
          // this regexp will capture the contents of the `cookieId` cookie, on the serialized
          // cookie array returned by `document.cookie` OR the full contents of the cookie in case
          // `cookieId` does not exist on the cookie array
          // documented example: https://regex101.com/r/MDDrsY/1
          const cookieRegex = new RegExp(
            '(?:(?:^|.*;\\s*)' + cookieId + '\\s*=\\s*([^;]*).*$)|^.*$'
          );

          // we're using `document.cookie.replace` as a hack to extract the cookie value (returned from the
          // `replace` function) and "replacing" it with the same value, and then decoding the content of
          // the cookies as a json object
          var heapIdCookie = JSON.parse(
            decodeURIComponent(document.cookie.replace(cookieRegex, '$1'))
          );

          if (heapIdCookie) {
            const v4IdentityFielddCesent = heapIdCookie.identityField !== null;
            const currentIdentityIsDifferent = heapIdCookie.identity !== email;

            // if we detect identity field (idv4) or if we detect an identity and that identity is not equal to the one provided by the application
            // we resetIdentity to clear the client cookie, then set the identity.
            if (v4IdentityFielddCesent || currentIdentityIsDifferent) {
              window.heap.resetIdentity();
              window.heap.track('Identify Call', heapIdCookie); // make a track call with the contents of the identity cookie in lieu of telemetry.
              window.heap.identify(email);
              window.heap.addUserProperties(traits);
            }
          }
        } else {
          // no cookie yet set, it's OK to immediately call identify
          window.heap.identify(email);
        }
      } catch (e) {
        window.heap.track('Identity Error', { error: e.toString() });
      }
    },

    loaded: () => {
      return !!window.heap;
    },
  };
}
